import { render, staticRenderFns } from "./CustomNavbar.vue?vue&type=template&id=65f6fb9a&scoped=true"
import script from "./CustomNavbar.vue?vue&type=script&lang=js"
export * from "./CustomNavbar.vue?vue&type=script&lang=js"
import style0 from "./CustomNavbar.vue?vue&type=style&index=0&id=65f6fb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6fb9a",
  null
  
)

export default component.exports